import React, { Component } from "react";
import { getRequest } from "../api";

import Main from "../layouts/Main";

import Hero from "../components/Hero";
import { Features, CTA, Testimonials, Blog } from "../components/HomePage";

class Index extends Component {
  state = {
    blogPosts: [],
    assets: [],
    limit: 3,
    skip: 0
  };

  getBlogPosts = async () => {
    const { limit, skip } = this.state;

    try {
      const res = await getRequest({
        url: 'entries',
        params: {
          access_token: "qvwzHgDak_-zkrmMQidw7IXtM4U4Xs-M9SdFJl6kJMM",
          limit,
          skip,
          content_type: "blogPost"
        }
      }) 

      this.setState({
        blogPosts: res.data.items,
        assets: res.data.includes.Asset
      });
    } catch (error) {
      console.log(error);
    }
  };

  componentDidMount() {
    this.getBlogPosts();
  }

  render() {
    const { blogPosts, assets } = this.state;

    return (
      <Main>
        <Hero />
        <Features />
        <Blog blogPosts={blogPosts} assets={assets} />
        <Testimonials />
      </Main>
    );
  }
}

export default Index;
